import type { ApiResponse, CreateOrderInput, Order, OrderStatus } from '@cracked-mug/shared';
import { api } from './api';

function unwrap<T>(payload: ApiResponse<T>): T {
  if (!payload.success) {
    throw new Error(payload.error);
  }
  return payload.data;
}

export async function createOrder(input: CreateOrderInput): Promise<Order> {
  const res = await api.post<ApiResponse<Order>>('/orders', input);
  return unwrap(res.data);
}

export async function fetchMyOrders(): Promise<Order[]> {
  const res = await api.get<ApiResponse<Order[]>>('/orders/my');
  return unwrap(res.data);
}

export async function fetchOrder(orderId: string): Promise<Order> {
  const res = await api.get<ApiResponse<Order>>(`/orders/${orderId}`);
  return unwrap(res.data);
}

export async function fetchAllOrders(filters?: {
  status?: OrderStatus;
  teacherId?: string;
  fromDate?: string;
  toDate?: string;
  limit?: number;
}): Promise<Order[]> {
  const res = await api.get<ApiResponse<Order[]>>('/orders', { params: filters });
  return unwrap(res.data);
}

export async function updateOrderStatus(orderId: string, status: OrderStatus): Promise<Order> {
  const res = await api.patch<ApiResponse<Order>>(`/orders/${orderId}/status`, { status });
  return unwrap(res.data);
}

export async function cancelOrder(orderId: string): Promise<Order> {
  const res = await api.delete<ApiResponse<Order>>(`/orders/${orderId}`);
  return unwrap(res.data);
}
